import React from 'react'

const SaisieDoubleFormulaire = () => {
    return (
        <div>SaisieDoubleFormulaire</div>
    )
}

export default SaisieDoubleFormulaire